// Fresh-eyes 19 (Carla, 2026-10-12): calendar events that are stored as task rows.
//
// A booking, an event synced from a connected calendar, an accepted calendar invite and an
// accepted email suggestion each become a task row on the server (so they can be opened,
// moved and completed), and every list drew them as tasks WITH A PRIORITY. They are meetings:
// shown in their own style, with no priority, and with a clean title. This is the one place
// that decides which rows are meetings, and the one title cleaner; the server's twin is
// "Aidey Backend/lib/eventSuggestions.js" (cleanEventTitle), which cleans titles as they are
// stored. This one cleans rows stored before that.
//
// A task someone created and typed "Meeting" is still their task: it keeps its priority.
// A booking follow-up (source booking_trigger) is a task too.
const CALENDAR_SOURCES = new Set(['scheduler_booking', 'calendar_sync', 'invite', 'email_event']);

export function isCalendarEventTask(task) {
  if (!task) return false;
  if (task.external === true) return true;   // a Google / iCal / Outlook event merged in on the client
  if (task.bookingId != null && task.source !== 'booking_trigger') return true;
  return CALENDAR_SOURCES.has(task.source);
}

const PREFIX_RE = /^\s*(?:re|fwd?|fw|confirmation|confirmed|invitation|updated invitation|new event|accepted|declined|tentative|tentatively accepted|reminder|cancell?ed(?: event)?|booking confirmed|booking confirmation)\s*(?::|-|–|—)\s*/i;

export function cleanEventTitle(title) {
  if (title == null) return '';
  let s = String(title).trim();
  for (let i = 0; i < 6; i++) {
    const next = s.replace(PREFIX_RE, '');
    if (next === s || !next.trim()) break;
    s = next.trim();
  }
  // Google Calendar's invite subject: "Board meeting @ Tue 13 Oct 2026 10am - 11am (BST) (...)".
  return s.replace(/\s+@\s+(?:mon|tue|wed|thu|fri|sat|sun)[a-z]*\b.*$/i, '').trim();
}

// The title a list shows: cleaned for a calendar event, exactly as typed for anything else.
export function taskDisplayTitle(task) {
  if (!task) return '';
  const title = task.title == null ? '' : String(task.title);
  return isCalendarEventTask(task) ? (cleanEventTitle(title) || title) : title;
}
